<template>
  <!-- <div class="container"> -->
  <!-- <div class="title">基地详情</div> -->
  <div class="mapbox">
    <div class="bg-image">
      <!-- 设置各个基地可选择点击的区域 -->
      <div class="field1" @click="openDialog1"></div>

      <div class="field2" @click="openDialog2"></div>

      <div class="field3" @click="openDialog3"></div>

      <div class="field4" @click="openDialog4"></div>

      <div class="field5" @click="openDialog5"></div>
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      custom-class="field-dialog"
      :modal="false">
      <div class="dialog-container">
        <!-- 第一列 -->
        <div class="dialog-col">
          <div class="col-title">基本信息</div>
          <div class="col-content">
            <div class="dialog-row">
              <span class="key">归属合作社</span>
              <span class="val">{{ fieldData.baseInfo?.coop }}</span>
            </div>
            <div class="dialog-row">
              <span class="key">面积</span>
              <span class="val">{{ fieldData.baseInfo?.area }}</span>
            </div>
            <div class="dialog-row">
              <span class="key">负责人</span>
              <span class="val">{{ fieldData.baseInfo?.manager }}</span>
            </div>
            <div class="dialog-row">
              <span class="key">联系电话</span>
              <span class="val">{{ fieldData.baseInfo?.phone }}</span>
            </div>
          </div>
        </div>

        <!-- 第二列 -->
        <div class="dialog-col">
          <div class="col-title">养殖信息</div>
          <div class="col-content">
            <div class="dialog-row">
              <span class="key">养殖品种</span>
              <span class="val">{{ fieldData.breedInfo?.type }}</span>
            </div>
            <div class="dialog-row">
              <span class="key">预计产量</span>
              <span class="val">{{ fieldData.breedInfo?.expectedOutput }}</span>
            </div>
            <div class="dialog-row">
              <span class="key">养殖周期</span>
              <span class="val">{{ fieldData.breedInfo?.cycle }}</span>
            </div>
            <div class="dialog-row">
              <span class="key">投苗数量</span>
              <span class="val">{{ fieldData.breedInfo?.seedAmount }}</span>
            </div>
          </div>
        </div>

        <!-- 第三列 -->
        <div class="dialog-col">
          <div class="col-title">农事操作</div>
          <div class="col-content">
            <div class="dialog-row" v-for="(item, index) in fieldData.farmInfo" :key="index">
              <span class="key">{{ item.date }}</span>
              <span class="val">{{ item.action }} - {{ item.detail }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
  <!-- </div> -->
</template>

<script>
export default {
  name: 'BaseDetail',

  data() {
    return {
      dialogVisible: false,
      fieldName: '',
      fieldData: {},

      // mock数据
      fieldsMock: {
        1: {
          baseInfo: {
            area: '24.36亩',
            coop: '稻虾一号合作社',
            manager: '张建国',
            phone: '13800001234'
          },
          breedInfo: {
            type: '小龙虾',
            expectedOutput: '300kg',
            cycle: '2026.03 - 2026.08',
            seedAmount: '120kg'
          },
          farmInfo: [
            { date: '2026-03-05', action: '投苗', detail: '投放120kg虾苗' },
            { date: '2026-03-18', action: '施肥', detail: '有机肥 50kg' },
            { date: '2026-04-02', action: '消毒', detail: '生石灰消毒' },
            { date: '2026-04-20', action: '营养液', detail: '藻类营养液' }
          ]
        },

        2: {
          baseInfo: {
            area: '18.2亩',
            coop: '丰收合作社',
            manager: '李强',
            phone: '13900004567'
          },
          breedInfo: {
            type: '小龙虾',
            expectedOutput: '260kg',
            cycle: '2026.03 - 2026.07',
            seedAmount: '100kg'
          },
          farmInfo: [
            { date: '2026-03-06', action: '投苗', detail: '投放100kg虾苗' },
            { date: '2026-03-25', action: '消毒', detail: '二氧化氯' }
          ]
        },

        3: {
          baseInfo: {
            area: '30.5亩',
            coop: '绿源生态合作社',
            manager: '王大军',
            phone: '13700007890'
          },
          breedInfo: {
            type: '小龙虾',
            expectedOutput: '420kg',
            cycle: '2026.03 - 2026.08',
            seedAmount: '150kg'
          },
          farmInfo: [
            { date: '2026-03-04', action: '投放虾苗', detail: '规格35尾/斤，150kg' },
            { date: '2026-03-15', action: '水质消毒', detail: '生石灰 40kg' },
            { date: '2026-03-30', action: '肥水培藻', detail: '肥水膏 20kg' },
            { date: '2026-04-18', action: '营养补充', detail: '葡萄糖 + 维生素C' },
            { date: '2026-06-25', action: '第一次捕捞', detail: '捕捞120kg' }
          ]
        },

        4: {
          baseInfo: {
            area: '26.8亩',
            coop: '丰联水产合作社',
            manager: '刘志强',
            phone: '13600006543'
          },
          breedInfo: {
            type: '小龙虾',
            expectedOutput: '350kg',
            cycle: '2026.03 - 2026.07',
            seedAmount: '130kg'
          },
          farmInfo: [
            { date: '2026-03-06', action: '投放虾苗', detail: '规格40尾/斤，130kg' },
            { date: '2026-03-20', action: '水草种植', detail: '伊乐藻种植' },
            { date: '2026-04-05', action: '水质改良', detail: '光合菌 10kg' },
            { date: '2026-04-22', action: '病害预防', detail: 'EM菌泼洒' },
            { date: '2026-06-18', action: '第一次捕捞', detail: '捕捞95kg' }
          ]
        },

        5: {
          baseInfo: {
            area: '22.4亩',
            coop: '兴农合作社',
            manager: '陈伟',
            phone: '13500004321'
          },
          breedInfo: {
            type: '小龙虾',
            expectedOutput: '280kg',
            cycle: '2026.03 - 2026.07',
            seedAmount: '110kg'
          },
          farmInfo: [
            { date: '2026-03-08', action: '投放虾苗', detail: '规格38尾/斤，110kg' },
            { date: '2026-03-22', action: '消毒', detail: '二氧化氯消毒' },
            { date: '2026-04-10', action: '肥水', detail: '氨基酸肥水液' },
            { date: '2026-05-02', action: '营养补充', detail: '矿物质营养液' },
            { date: '2026-06-15', action: '第一次捕捞', detail: '捕捞70kg' }
          ]
        }
      }
    }
  },

  computed: {
    dialogTitle() {
      return `稻虾 ${this.fieldName} 号田基本信息`
    }
  },

  methods: {
    openDialog(index) {
      this.dialogVisible = true
      this.fieldName = index
      this.fieldData = this.fieldsMock[index] || {
        baseInfo: {},
        breedInfo: {},
        farmInfo: []
      }
    },

    openDialog1() {
      this.openDialog(1)
    },
    openDialog2() {
      this.openDialog(2)
    },
    openDialog3() {
      this.openDialog(3)
    },
    openDialog4() {
      this.openDialog(4)
    },
    openDialog5() {
      this.openDialog(5)
    }

    // openDialog1() {
    //   this.dialogVisible = true
    //   this.fieldName = 1
    // },

    // openDialog2() {
    //   this.dialogVisible = true
    //   this.fieldName = 2
    // },

    // openDialog3() {
    //   this.dialogVisible = true
    //   this.fieldName = 3
    // },

    // openDialog4() {
    //   this.dialogVisible = true
    //   this.fieldName = 4
    // },

    // openDialog5() {
    //   this.dialogVisible = true
    //   this.fieldName = 5
    // }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  /* 核心：确保每个组件都继承父级分配的高度 */
  /* height: calc(100% - 12px); */
  /* background: url('../images/bg_block.png') no-repeat; */
  height: 100%;
  position: relative;
  margin-bottom: 12px;
  z-index: 10;
  display: flex;
  flex-direction: column; /* 内部内容也纵向排列 */
}

.mapbox {
  /* height: 100%;
  padding: 16px;
  border-radius: 12px;
  border: 3px solid rgb(5 175 211 / 91%);
  box-shadow: 0 0 20px rgba(0, 191, 255, 0.4), inset 0 0 50px rgba(0, 191, 255, 0.5),
    inset 0 0 2px rgba(255, 255, 255, 0.3);
  background: radial-gradient(circle at center, rgba(0, 32, 63, 0.4) 0%, rgba(0, 8, 20, 0.8) 100%);
  backdrop-filter: blur(0.0625rem);
  position: relative;
  transition: all 0.3s ease; */
  height: 100%;
  padding: 16px;
}

.bg-image {
  width: 100%;
  height: 100%;
  background: url('../assets/images/bg_middle_pic3.jpg') no-repeat center center;
  background-size: cover;
  background-position: center;
  border-radius: 12px;
  position: relative;
}

.field1 {
  position: absolute;
  left: 20%;
  top: 76%;
  cursor: pointer;
  width: 100px;
  height: 40px;
  text-align: center;
  /* background-color: #fff; */
}

.field2 {
  position: absolute;
  left: 33%;
  top: 71%;
  cursor: pointer;
  width: 100px;
  height: 40px;
  text-align: center;
  /* background-color: #fff; */
}

.field3 {
  position: absolute;
  left: 41%;
  top: 48%;
  cursor: pointer;
  width: 100px;
  height: 40px;
  text-align: center;
  /* background-color: #fff; */
}

.field4 {
  position: absolute;
  left: 52%;
  top: 67%;
  cursor: pointer;
  width: 100px;
  height: 40px;
  text-align: center;
  /* background-color: #fff; */
}

.field5 {
  position: absolute;
  left: 66%;
  top: 41%;
  cursor: pointer;
  width: 100px;
  height: 40px;
  text-align: center;
  /* background-color: #fff; */
}

::v-deep .el-dialog__header {
  padding: 8px 20px 20px 8px;
  text-align: center;
}

::v-deep .el-dialog__headerbtn {
  top: 8px;
  right: 8px;
}

::v-deep .el-dialog__body {
  padding: 18px 15px;
}

::v-deep .field-dialog {
  background: rgba(0, 20, 50, 0.95);
  border-radius: 12px;
  border: 2px solid rgb(5 175 211 / 91%);
  box-shadow: 0 0 20px rgba(0, 191, 255, 0.4), inset 0 0 50px rgba(0, 191, 255, 0.5),
    inset 0 0 2px rgba(255, 255, 255, 0.3);
  margin-top: 350px !important;
  width: 650px;
  min-height: 300px;
}

::v-deep .field-dialog .el-dialog__title {
  color: #00e5ff;
  font-size: 16px;
}

::v-deep .field-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #00e5ff;
}

.dialog-row {
  display: flex;
  justify-content: space-between;
  padding: 6.4px 0;
  border-bottom: 1px solid rgba(0, 229, 255, 0.15);
  font-size: 11.2px;
}

.key {
  color: #7ecfff;
}
.val {
  color: #ffffff;
}

/* 三列容器 */
.dialog-container {
  display: flex;
  gap: 12px;
}

/* 每一列 */
.dialog-col {
  flex: 1; /* 三列等宽 */
  border: 1px solid rgba(0, 229, 255, 0.3);
  border-radius: 6.4px;
  padding: 9.6px;
  background: rgba(0, 229, 255, 0.05);
  min-height: 180px;
}

/* 列标题 */
.col-title {
  color: #00e5ff;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  padding-bottom: 8px;
  margin-bottom: 8px;
  border-bottom: 1px solid rgba(0, 229, 255, 0.3);
}

/* 每行数据 */
.dialog-row {
  display: flex;
  justify-content: space-between;
  padding: 5.6px 0;
  border-bottom: 1px solid rgba(0, 229, 255, 0.1);
  font-size: 10.4px;
}
</style>
